/* eslint-disable global-require */
export { default } from './get-validation-result';



// WEBPACK FOOTER //
// ./src/helpers/validation/index.js